import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

function ConfirmModal({
  type = "approve", // "approve", "reject", "revision", "forward", "save-assessment", or "select"
  show,
  handleClose,
  onConfirm,
  message, // optional override for the confirmation body text (used by "forward")
  reasonOptions = [] // optional quick-pick reasons, only rendered for type="reject"
}) {
  const [remark, setRemark] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const isReject = type === "reject";
  const isRevision = type === "revision";
  const isForward = type === "forward";
  const isSaveAssessment = type === "save-assessment";
  const isSelect = type === "select";

  const handleConfirm = () => {
    if (isReject && !selectedReason && remark.trim() === "") {
      return alert("Please select a reason or add a remark before rejecting.");
    }
    if (isRevision && remark.trim() === "") {
      return alert("Please add a remark for the revision request.");
    }
    const value = isReject
      ? (selectedReason && remark.trim() ? `${selectedReason} — ${remark.trim()}` : (selectedReason || remark.trim()))
      : remark;
    onConfirm(value);
    handleClose();
    setRemark("");
    setSelectedReason("");
  };

  return (
    <Modal show={show} onHide={handleClose}  centered  >
      <div className="p-3 ">
      <div >
        <div className="d-flex ">
          <div>
          <span
            className={`me-2 rounded d-flex justify-content-center align-items-center `}
            style={{
              width: "60px",
              height: "55px",
              backgroundColor: isReject ? "#fdecea" : isRevision ? "#FFF3CD" : isForward ? "#EEF2FF" : isSaveAssessment ? "#EEF2FF" : isSelect ? "#FEF3C7" : "#eafaf1",
              color: isReject ? "#d93025" : isRevision ? "#856404" : isForward ? "#4338CA" : isSaveAssessment ? "#4338CA" : isSelect ? "#B7791F" : "#1e8e3e",
              fontSize: "20px",
            }}
          >
            {isReject ? "✖" : isRevision ? "✎" : isForward ? "➜" : isSaveAssessment ? "✔" : isSelect ? "✔" : "✔"}
          </span>
          </div>
          <div>
          <div className="" style={{fontSize:"20px", fontWeight:"500",color:"#000000"}}>
            {isReject ? "Reject Request" : isRevision ? "Request Revision" : isForward ? "Send Forward" : isSaveAssessment ? "Confirm Assessment Submission" : isSelect ? "Confirm Selection" : "Approve Request"}

            {isReject ? (<p style={{fontSize:"14px", fontWeight:"400",color:"#6B7280"}}>
              You've rejected this request. Please add a remark so the user understands the reason.
            </p>) : isRevision ? (<p style={{fontSize:"14px", fontWeight:"400",color:"#6B7280"}}>
              Add a remark explaining what changes the user needs to make before resubmitting.
            </p>) : isForward ? (<p style={{fontSize:"14px", fontWeight:"400",color:"#6B7280"}}>
              {message || "Are you sure you want to send the selected applications forward?"}
            </p>) : isSaveAssessment ? (<p style={{fontSize:"14px", fontWeight:"400",color:"#6B7280"}}>
              This assessment can only be submitted once and cannot be edited afterward. Please review all values carefully before confirming.
            </p>) : isSelect ? (<p style={{fontSize:"14px", fontWeight:"400",color:"#6B7280"}}>
              {message || "Are you sure you want to mark the selected applications as Selected? This is a final decision and cannot be undone."}
            </p>) : (<p style={{fontSize:"14px", fontWeight:"400",color:"#6B7280"}}>
              Are you sure you want to Approve Request?
            </p>)}
             
          </div>
          </div>
        </div>
      </div>

      <div className="py-0" style={{paddingTop:"0px"}}>
        {isReject && reasonOptions.length > 0 && (
          <div className="mb-3">
            <div style={{color:"#000000", marginBottom: "8px"}}>
              Select a Reason
            </div>
            <div className="d-flex flex-wrap gap-2">
              {reasonOptions.map((reason) => {
                const isSelected = selectedReason === reason;
                return (
                  <button
                    type="button"
                    key={reason}
                    onClick={() => setSelectedReason(isSelected ? "" : reason)}
                    style={{
                      border: isSelected ? "1px solid #C62828" : "1px solid #D1D5DB",
                      backgroundColor: isSelected ? "#fdecea" : "#FFFFFF",
                      color: isSelected ? "#C62828" : "#4B5563",
                      borderRadius: "16px",
                      padding: "6px 14px",
                      fontSize: "13px",
                      lineHeight: 1.3,
                      textAlign: "left",
                    }}
                  >
                    {reason}
                  </button>
                );
              })}
            </div>
          </div>
        )}
        {(isReject || isRevision) ? (
          <>
            <Form.Group>
              <div style={{color:"#000000"}}>
                Add Remark {(isRevision || (isReject && reasonOptions.length === 0)) && <span style={{ color: "red" }}>*</span>}
                {isReject && reasonOptions.length > 0 && (
                  <span style={{ fontSize: "12px", fontWeight: 400, color: "#6B7280" }}> (required if no reason selected above)</span>
                )}
              </div>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter your remark..."
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Form.Group>
          </>
        ) : (
          ""
        )}
      </div>

      <div className="d-flex justify-content-end border-0 gap-3 mt-4">
        <Button style={{backgroundColor:"#FFFFFF" ,color:"#4B5563",borderColor:"#D1D5DB",padding:"8px 16px"}} onClick={handleClose}>
          Go Back
        </Button>
        <Button
          style={{
            backgroundColor: isReject ? "#C62828" : isRevision ? "#856404" : isForward ? "#4338CA" : isSaveAssessment ? "#4338CA" : isSelect ? "#B7791F" : "#4AA564",
            border: "none",
            padding:"8px 16px"
          }}
          onClick={handleConfirm}
        >
          {isReject ? "Yes, Reject" : isRevision ? "Send Revision Request" : isForward ? "Yes, Forward" : isSaveAssessment ? "Yes, Submit Assessment" : isSelect ? "Yes, Select" : "Yes, Approve"}
        </Button>
      </div>
      </div>
    </Modal>
  );
}

export default ConfirmModal;
